import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import type { InvitedModes } from "api/models/draftRequest.model";
import { useGetFreightModesConfig } from "api/queries/location/useGetFreightModesConfig";
import usePermissions from "hooks/usePermissions";
import { hasAirOrOceanInvitedMode } from "@RequestFormV2/utils/invitedModesHelpers";

export default function useShowConsigneeSection() {
  const { permissions } = usePermissions();
  const location = useWatch({ name: "organizational.location" });
  const invitedModes = useWatch({ name: "invited_modes" }) as InvitedModes | undefined;

  const notifyPartyAndConsigneeEnabled = useMemo(() => {
    if (!permissions) return false;
    const { notify_party_and_consignee } = JSON.parse(permissions)?.company_shipper_settings ?? {};
    return Boolean(notify_party_and_consignee);
  }, [permissions]);

  const { data: freightModesConfig } = useGetFreightModesConfig(location ?? "", {
    enabled: Boolean(location),
  });

  const availableModes = freightModesConfig?.freight_modes?.available_modes ?? [];

  const hasAtLeastOneAirOrOcean = useMemo(
    () => hasAirOrOceanInvitedMode(invitedModes, availableModes),
    [invitedModes, availableModes],
  );

  return notifyPartyAndConsigneeEnabled && hasAtLeastOneAirOrOcean;
}
